import withApollo from '@chegg-wt/core/api/graphApi'
import React from 'react'
import { useRouter } from 'next/router'
import useRedirect from '@chegg-wt/core/hooks/useRedirect'
import { useRoutesContext } from '@chegg-wt/core/components/RoutesContext'
import useUserRole from '@chegg-wt/core/hooks/useUserRole'

import { UserRoles } from '@chegg-wt/core/constants/user'
import { sourceTypeById } from '@chegg-wt/core/utils/sourceTypes'
import { citationFlowStepFromString } from '@chegg-wt/core/utils/citationFlow'
import CitationListContainer from '@chegg-wt/core/components/CitationListContainer'
import { useOnUnloadTimeOnPage } from '@chegg/time-on-page'
import { citationCopy } from '../../copy/citations'
import { exportTabIds } from '../../config/exportTab'

type QueryParams = {
  id: string
  sourceType?: string
  step?: string
  searchQuery?: string
}

const CitationListPage: React.FC = () => {
  const router = useRouter()
  const { id: projectId, sourceType, searchQuery, step } = router.query as QueryParams
  const { toDashboard } = useRoutesContext()
  const userRole = useUserRole()
  useRedirect({
    shouldRedirect: userRole !== UserRoles.PRO_USER,
    redirectRoute: toDashboard(),
  })

  useOnUnloadTimeOnPage()
  return (
    <CitationListContainer
      copy={citationCopy}
      projectId={projectId}
      exportTabIds={exportTabIds}
      initialSourceType={sourceTypeById(sourceType)}
      initialSearchQuery={searchQuery}
      flowStep={citationFlowStepFromString(step)}
    />
  )
}

export default withApollo()(CitationListPage)
